// =============================================================================
// TriggerMapModal
//
// Confirmation modal before firing a manual MAP pull for a client.
// =============================================================================

import { FunctionComponent } from "react";
import { TRIGGER_MAP_MODAL } from "src/constants/adminDashboard";
import RepairMapModal from "./RepairModal"

interface TriggerMapModalProps {
  clientName: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

const TriggerMapModal: FunctionComponent<TriggerMapModalProps> = ({
  clientName,
  onConfirm,
  onCancel,
  loading,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-lg">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">
        {TRIGGER_MAP_MODAL.title}
      </h3>
      <p className="text-sm text-gray-600 mb-6">
        {TRIGGER_MAP_MODAL.body(clientName)}
      </p>
      <div className="flex gap-3 justify-end">
        <button
          onClick={onCancel}
          disabled={loading}
          className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50"
        >
          {TRIGGER_MAP_MODAL.cancel}
        </button>
        <button
          onClick={onConfirm}
          disabled={loading}
          className="px-4 py-2 text-sm text-white bg-primary rounded disabled:opacity-50"
        >
          {loading ? "Processing..." : TRIGGER_MAP_MODAL.confirm}
        </button>
      </div>
    </div>
  </div>
);

export default TriggerMapModal;

